import { render, staticRenderFns } from "./PagesCountAreaReportComponent.vue?vue&type=template&id=0e897290&scoped=true"
import script from "./PagesCountAreaReportComponent.vue?vue&type=script&lang=js"
export * from "./PagesCountAreaReportComponent.vue?vue&type=script&lang=js"
import style0 from "./PagesCountAreaReportComponent.vue?vue&type=style&index=0&id=0e897290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e897290",
  null
  
)

export default component.exports